var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9832_5392)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9832_5392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9832_5392)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9832_5392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9832_5392)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9832_5392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9832_5392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9832_5392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9832_5392)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9832_5392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9832_5392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9832_5392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9832_5392)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9832_5392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 8,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6V14H13V6H5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9832_5392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21611 6.21611C5.11674 6.31454 5.04778 6.43944 5.01741 6.57598C4.98704 6.71248 4.99654 6.85484 5.04478 6.98611L5.07044 7.05811C5.59051 8.66624 6.47968 10.1304 7.66678 11.3334C8.34371 11.9375 9.08674 12.463 9.88178 12.9001L10.6668 12.1381L11.5288 13.0001L12.0001 12.5288L11.1381 11.6668L11.9114 10.8935C11.4742 10.0986 10.9487 9.35568 10.3448 8.67878C9.13748 7.48771 7.66918 6.59441 6.05644 6.06978L5.98611 6.04478C5.85484 5.99654 5.71248 5.98704 5.57594 6.01741C5.43944 6.04781 5.31454 6.11678 5.21611 6.21611ZM9.66678 10.3335C9.66678 10.3994 9.64721 10.4638 9.61058 10.5187C9.57398 10.5735 9.52191 10.6162 9.46101 10.6414C9.40008 10.6667 9.33308 10.6733 9.26841 10.6604C9.20374 10.6475 9.14434 10.6158 9.09774 10.5692C9.05111 10.5226 9.01938 10.4632 9.00651 10.3985C8.99364 10.3338 9.00024 10.2668 9.02548 10.2059C9.05071 10.145 9.09344 10.0929 9.14824 10.0563C9.20308 10.0197 9.26751 10.0001 9.33344 10.0001C9.42184 10.0001 9.50661 10.0353 9.56914 10.0978C9.63164 10.1603 9.66678 10.2451 9.66678 10.3335ZM8.66678 9.33344C8.66678 9.39938 8.64721 9.46381 8.61058 9.51864C8.57398 9.57344 8.52191 9.61618 8.46101 9.64141C8.40008 9.66664 8.33308 9.67324 8.26841 9.66038C8.20374 9.64751 8.14434 9.61578 8.09774 9.56914C8.05111 9.52254 8.01938 9.46314 8.00651 9.39848C7.99364 9.33381 8.00024 9.26678 8.02548 9.20588C8.05071 9.14498 8.09344 9.09291 8.14824 9.05628C8.20308 9.01964 8.26751 9.00011 8.33344 9.00011C8.42184 9.00011 8.50661 9.03524 8.56914 9.09774C8.63164 9.16024 8.66678 9.24504 8.66678 9.33344ZM7.66678 8.33344C7.66678 8.39938 7.64721 8.46381 7.61058 8.51864C7.57398 8.57344 7.52191 8.61618 7.46101 8.64141C7.40008 8.66664 7.33308 8.67324 7.26841 8.66038C7.20374 8.64751 7.14434 8.61578 7.09774 8.56914C7.05111 8.52254 7.01938 8.46314 7.00651 8.39848C6.99364 8.33381 7.00024 8.26678 7.02548 8.20588C7.05071 8.14498 7.09344 8.09291 7.14824 8.05628C7.20308 8.01964 7.26751 8.00011 7.33344 8.00011C7.42184 8.00011 7.50661 8.03524 7.56914 8.09774C7.63164 8.16024 7.66678 8.24504 7.66678 8.33344ZM10.2541 7.68444C10.7925 7.72628 11.3158 7.88218 11.7892 8.14184C12.2627 8.40151 12.6754 8.75894 13.0001 9.19044V10.3335H12.3594C11.927 9.56871 11.4093 8.85541 10.8164 8.20711C10.6334 8.02344 10.4448 7.85111 10.2541 7.68444ZM7.18944 11.8164C7.83771 12.4094 8.55104 12.927 9.31578 13.3594V14.0001H8.17278C7.74128 13.6754 7.38384 13.2627 7.12418 12.7892C6.86451 12.3158 6.70858 11.7925 6.66678 11.2541C6.83344 11.4448 7.00578 11.6334 7.18944 11.8164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.665 12.1364L11.5691 13.0404L12.0405 12.569L11.1364 11.665L10.665 12.1364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93018 5.93188L6.08781 6.57478L5.57308 7.08955L4.93018 5.93188Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9832_5392",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9832_5392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9832_5392",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9832_5392",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9832_5392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/Action.aabebc66ecb106f277e53a0e13fd3038.svg";
export { ForwardRef as ReactComponent };